import React from 'react';

import CourseCompare from './CourseCompare';
import useCourseCompare from 'Redux/courseCompare';

const CourseCompareContainer: React.FC = () => {
    const { store, removeCourse, clearCourses } = useCourseCompare();

    return (
        <CourseCompare
            courses={store.courses}
            removeCourse={removeCourse}
            clearCourses={clearCourses}
        />
    );
};

export default CourseCompareContainer;
